/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,

  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AllInboxOutlinedIcon from "@mui/icons-material/AllInboxOutlined";
import { useState, useEffect } from "react";
import { cambiaBandeja } from "../../services/ProduccionService";
import DatosGestionAtencionCliente from "./DatosGestionAtencionCliente";
import DatosAnteojoArreglo from "./DatosAnteojoArreglo";
import { isNumeric } from "../../utils/utils";
import DatosBandejaActual from "./DatosBandejaActual";
import DatosAreaActual from "./DatosAreaActual";
import DatosAccordion from "./DatosAccordion";
import WaitingDialog from "../../utils/WaitingDialog";

const initialCambiarBandejaData = {
  bandejaNueva: "",
  observaciones: "",
};
//
// ###########################################################################
//
const CambiarBandejaAnteojoArregloDialog = ({
  idGestionAtencion,
  anteojoArreglo,
  codigoAnteojoArreglo,
  idGcAnteojoArreglo,
  onCambiarBandeja,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [cambiarBandejaData, setCambiarBandejaData] = useState(initialCambiarBandejaData);
  const [bandejaActual, setBandejaActual] = useState(0);
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [datosAccordionSummaryCargados, setDatosAccordionSummaryCargados] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (accordionExpanded && !datosAccordionSummaryCargados) {
      setDatosAccordionSummaryCargados(true);
    }
  }, [accordionExpanded]);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setCambiarBandejaData({
      ...cambiarBandejaData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const getBandejaActual = (parBandejaActual) => {
    setBandejaActual(parBandejaActual);
  };
  //
  // ################################################################################
  //
  const getAreaActual = (parAreaActual) => { };
  //
  // ################################################################################
  //
  const cambiarBandeja = () => {
    console.log("---");
    console.log("in ");
    console.log("bandejaActual");
    console.log(bandejaActual);
    console.log();

    console.log("---");
    console.log("in ");
    console.log("cambiarBandejaData.bandejaNueva");
    console.log(cambiarBandejaData.bandejaNueva);
    console.log();

    if (!cambiarBandejaData.bandejaNueva) {
      // si no se ha indicado la nueva bandeja

      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de la nueva bandeja",
      });
      setShowMessage(true);
      return;
    }

    if (!isNumeric(cambiarBandejaData.bandejaNueva)) {
      // si no se ha indicado la bandeja

      setMessage({
        severity: "error",
        messageText: "No es correcto el número de bandeja ingresado",
      });
      setShowMessage(true);
      return;
    }

    if (bandejaActual == cambiarBandejaData.bandejaNueva) {
      // si no se ha cambiando la nueva bandeja

      setMessage({
        severity: "error",
        messageText: "No es posible asignar la misma bandeja",
      });
      setShowMessage(true);
      return;
    }

    let _cambiarBandejaObject = {
      anteojo_arreglo: anteojoArreglo,
      id_gc_anteojo_arreglo: idGcAnteojoArreglo,
      bandeja_actual: bandejaActual,
      bandeja_nueva: +cambiarBandejaData.bandejaNueva,
      observaciones: cambiarBandejaData.observaciones,
    };
    save(_cambiarBandejaObject);
  };
  //
  // ################################################################################
  //
  const save = async (parCambiaBandeja) => {
    setIsDoingSomething(true);
    const response = await cambiaBandeja(parCambiaBandeja);
    setIsDoingSomething(false);

    if (response.ok) {
      onCambiarBandeja();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          CAMBIO DE BANDEJA {anteojoArreglo.toUpperCase()} {codigoAnteojoArreglo}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Accordion
            sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
            expanded={accordionExpanded}
            onChange={() => {
              setAccordionExpanded(!accordionExpanded);
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <DatosAccordion idGestionAtencion={idGestionAtencion} />
            </AccordionSummary>
            <AccordionDetails>
              {datosAccordionSummaryCargados && (
                <>
                  {idGestionAtencion && (
                    <DatosGestionAtencionCliente idGestionAtencion={idGestionAtencion} />
                  )}

                  {anteojoArreglo && (
                    <>
                      <DatosAnteojoArreglo
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                      />

                      <DatosAreaActual
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                        setAreaActual={getAreaActual}
                      />
                    </>
                  )}
                </>
              )}
            </AccordionDetails>
          </Accordion>

          {anteojoArreglo && (
            <DatosBandejaActual
              anteojoArreglo={anteojoArreglo}
              idGcAnteojoArreglo={idGcAnteojoArreglo}
              setBandejaActual={getBandejaActual}
            />
          )}

          <Box
            sx={{
              border: "2px solid steelblue",
              borderRadius: "5px",
              p: 2,
            }}
          >
            <Grid container spacing={1} sx={{ mb: 1 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h6" gutterBottom>
                  Nueva bandeja asignada
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={2} lg={2}>
                <TextField
                  id="bandejaNueva"
                  label="Código de bandeja"
                  size="small"
                  sx={{ width: "100%" }}
                  type="number"
                  inputProps={{
                    autoComplete: "off",
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    style: { textAlign: "left" },
                  }}
                  name="bandejaNueva"
                  value={cambiarBandejaData.bandejaNueva}
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={10} lg={10}>
                <TextField
                  id="observaciones"
                  label="Observaciones"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    style: { textAlign: "left" },
                  }}
                  name="observaciones"
                  value={cambiarBandejaData.observaciones}
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box sx={{ textAlign: "right", p: 1 }}>
            <Button
              sx={{ mr: 1, backgroundColor: "warning" }}
              variant="contained"
              onClick={() => {
                cambiarBandeja();
              }}
              startIcon={<AllInboxOutlinedIcon />}
              disabled={isDoingSomething}
            >
              Cambiar bandeja
            </Button>
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              onClick={handleCloseDialog}
              disabled={isDoingSomething}
            >
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CambiarBandejaAnteojoArregloDialog;
